import { ImageCapabilityOpacityOptions } from '@trimble/web3d-capabilities';
import { FULLY_OPAQUE_STATION_OPACITY_FRACTION } from '@trimble/web3d-providers';
import type { ViewMode } from '../../view-mode';
import { PaneVisibilityCoordinator } from './pane-visibility-coordinator';

const TRANSPARENCY_MAX_PERCENT = 100;

const opacityFractionFromLevel = (level: number | null): number => {
  if (level == null || level >= TRANSPARENCY_MAX_PERCENT) {
    return FULLY_OPAQUE_STATION_OPACITY_FRACTION;
  }
  return level / TRANSPARENCY_MAX_PERCENT;
};

/**
 * Bridges the pane's image-domain opacity slider (panorama "Stations"
 * in panorama panes, planar "Image" in planar panes) into the existing
 * {@link ImageCapabilityOpacityOptions} contract. The two sliders are
 * separate states on {@link PaneVisibilityCoordinator}; we pick which
 * one to read based on the pane's current {@link ViewMode}.
 */
export function createImageStationOpacityOptions(
  getPaneVisibilityCoordinator: () => PaneVisibilityCoordinator | undefined,
  getViewMode: () => ViewMode | undefined
): ImageCapabilityOpacityOptions {
  return {
    resolveVisibleStationOpacity: () => {
      const cap = getPaneVisibilityCoordinator();
      if (!cap) return FULLY_OPAQUE_STATION_OPACITY_FRACTION;
      // Image mode = planar; everything else (Panorama, and the safe
      // default while view mode is still resolving) reads the stations
      // slider that mirrors global stations transparency.
      const source = getViewMode()?.type === 'Image' ? cap.image : cap.stations;
      return opacityFractionFromLevel(source.effective());
    },
  };
}
